import { RequestError } from './api.ts'

/** A filial the ERP has the number at, as the sync's 409 lists them. */
export interface SyncBranch {
  readonly code: number
  readonly name: string
}

/**
 * The filiais a refused sync named, or none.
 *
 * `POST /api/verifications/sync` without a filial answers 409 when the number
 * exists at more than one, and lists them in the body for the person to say
 * which. Anything else it refuses with has no list.
 */
export function branchesIn(cause: unknown): SyncBranch[] {
  if (!(cause instanceof RequestError) || cause.status !== 409) return []
  const listed = cause.body['branches']
  if (!Array.isArray(listed)) return []
  return listed.filter(
    (one): one is SyncBranch =>
      typeof one === 'object' &&
      one !== null &&
      typeof (one as SyncBranch).code === 'number' &&
      typeof (one as SyncBranch).name === 'string',
  )
}
